/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Status_ApprovedInputs */

const vi_stocktake_status_approved = /** @type {(inputs: Stocktake_Status_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã duyệt`)
};

/**

* @param {Stocktake_Status_ApprovedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_status_approved = /** @type {((inputs?: Stocktake_Status_ApprovedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Status_ApprovedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_status_approved(inputs)
});